module.exports = __webpack_public_path__ + "img/order-status-panel.780ab498.png";